import PropTypes from "prop-types";
import styled from "styled-components";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper/";

export const ErrorField = styled.div`
  display: flex;
  flex-direction: column;
`;
export const ErrorText = styled.span`
  display: ${({ error }) => (error ? "block" : "none")};
  color: ${({ theme }) => theme.colors.error};
  position: ${({ position }) => (position ? "fixed" : "absolute")};
  margin: ${({ margin }) => (margin ? margin : "0")};
  bottom: ${({ bottom }) => (bottom ? bottom : "unset")};
  ${media.lessThan(breakpoints.mobile)`
	margin: ${({ smallmargin }) => (smallmargin ? smallmargin : "")}
	`}
`;
export const ErrorSpan = styled.div`
  display: flex;
  flex-direction: ${({ row }) => (row ? "row" : "column")};
  padding: 1rem 0rem;
  width: ${({ half }) => (half ? "50%" : "100%")};
  align-self: ${({ half }) => (half ? "flex-start" : "")};
  align-items: ${({ center }) => (center ? "center" : "")};

  ${media.lessThan(breakpoints.mobile)`
	flex-direction: column;
`}
`;
